// extracted by mini-css-extract-plugin
export default {"section":"jobAdvertSection_section__KYzRd"};